export function hasVisibleText(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent?.trim() || "";
    return text !== "";
}
